// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3r3jX","gfeWrapper":"CalendarEvent_gfeWrapper__2Lym9"};